export default class ArrayUtils {
  /**
   * 取出最小與最大
   * @param {*} _levelList 資料
   * @returns 返回最小與最大
   */
  static getMinMaxValue(_levelList) {
    let Arr = _levelList;
    let minValue = Infinity;
    let maxValue = -Infinity;

    for (let item of Arr) {
      // Find minimum value
      if (item < minValue) minValue = item;

      // Find maximum value
      if (item > maxValue) maxValue = item;
    }
    console.log('minValue', minValue);
    console.log('maxValue', maxValue);

    return [minValue, maxValue ] ;
  }

  /**
   * Get Pts_time
   * @param {*} element 
   * @returns 
   */
  static getPts_time(element) {
    // pts_time
    const pts_timeArray = element.split(':');
    const pts_time = parseFloat(pts_timeArray[3]);

    return pts_time;
  }

  
  /**
   * Get Pts_time
   * @param {*} element 
   * @returns 
   */
  static getPts_time(element) {
    // pts_time
    let pts_timeArray = element.split(':');
    let pts_time = parseFloat(pts_timeArray[3]);

    return pts_time;
  }

  /**
   * Get Peak_level
   * @param {*} lastElement 
   * @returns 
   */
  static getPeak_level(lastElement) { 
    let Peak_level_timeArray = lastElement.split('=');
    var Peak_level = parseFloat(Peak_level_timeArray[1]);
    return Peak_level;
  }

  
}



// WEBPACK FOOTER //
// ./src/helper/ArrayUtils.js